import React, { useEffect, useRef, useState, useCallback } from "react";
import Footer from "./components/Footer";
import { Link, Outlet } from "react-router-dom";
import { funcTips } from "./mockData/mockData";
import NavItem from "./components/DownModal";
import './index.css';

function App() {
  const appRef = useRef(null);
  const [showNav, setShowNav] = useState(false);
  const navRef = useRef(null);
  const oldRef = useRef(0);

  const onScroll = useCallback(() => {
    if (appRef.current) {
      const { top: newY } = appRef.current.getBoundingClientRect();
      // 计算上下两次的移动的差值
      const delta = newY - oldRef.current;
      oldRef.current = newY;
      setShowNav(delta < 0 ? true : false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="app flex flex-col" ref={appRef}>
      <div>
        <nav
          className={
            `nav-header flex justify-center items-center h-[100px] bg-gradient-to-r from-cyan-500 to-blue-500 text-2xl`
          }
          // className={`${styles.link} ${showNav ? styles.hidden : styles.null}`}
          ref={navRef}
        >
          <div>
            <Link to="/">
              <span className="flex justify-center items-center">
                <img
                  className="w-36"
                  src='http://1.94.62.64:9090/myf/photos/logo_1.jpg'
                  alt="logo1"
                />
                <img
                  className="w-72"
                  src='http://1.94.62.64:9090/myf/photos/logo_2.jpg'
                  alt="logo2"
                />
              </span>

            </Link>
          </div>
          <div className="ml-[260px]">
            <NavItem funcTips={funcTips} />
          </div>
        </nav>
        <div className="relative flex-1">
          <Outlet />
        </div>
        <div className="flex-auto">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
